export default "__VITE_ASSET__8f5d6239__"